import { Get, Post } from "../../utils/http-utils";

export const getTargetsforPackage = async (queryParams = {}) => {
    return Get("/scm/package/thing", queryParams)
        .then((data) => {
            return data;
        })
        .catch((err) => {
            return [];
        });
};

export const creatDeployment = async (jsonPayload) => {
  return Post("/scm/package/deploy", jsonPayload)
    .then((data) => {
      return data;
    })
    .catch((err) => {
      throw err;
    });

}